import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface PersistState {
    chatWidth: number
    soundsEnabled: boolean
    setChatWidth: (width: number) => void
    setSoundsEnabled: (enabled: boolean) => void
}

export const usePersistStore = create<PersistState>()(
    persist(
        (set) => ({
            chatWidth: 450,
            soundsEnabled: true,
            setChatWidth: (width: number) => set({ chatWidth: width }),
            setSoundsEnabled: (enabled: boolean) => set({ soundsEnabled: enabled }),
        }),
        {
            name: 'medendo',
            version: 2,
            // v1 also stored _clickedTs (unread-row tracking, since removed) — drop it on upgrade.
            migrate: (persisted) => ({ chatWidth: (persisted as Partial<PersistState>)?.chatWidth ?? 450 }),
        }
    )
)
